import React from 'react'
import { l } from '@manychat/manyui'

import { SECONDS_IN_DAY } from 'components/DelayPicker/constants'
import { DelayPicker } from 'components/DelayPicker/DelayPicker'

import cm from './DelayControl.module.css'

type Value = number

interface DelayControlProps {
  value: Value
  onChange: (value: Value) => void
}

export const DelayControl: React.FC<DelayControlProps> = ({ value, onChange }) => {
  const delay = Math.abs(value) || SECONDS_IN_DAY

  return (
    <div className="p-a row middle">
      <DelayPicker className={cm.picker} delay={delay} onChange={onChange} minutes hours days />
      <div className="m-l-xs">{l.translate('ago')}</div>
    </div>
  )
}
